export enum CheckoutModalEnums {
  REVENUE = "revenue",
  OUTLAY = "outlay"
}
